
























































//import IconItemCategory from "@/common/components/icons/IconItemCategory.vue";
import DropdownMenuAnimation from "@/general/components/organisms/DropdownMenuAnimation.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowBottom from "@/common/components/icons/IconArrowBottom.vue";
import { Vue, Component, Prop } from "vue-property-decorator";
import InlineSvg from "vue-inline-svg";
import commons from "@/common/store/modules/commons";
import { mapState } from "vuex";

@Component({
  components: {
    //IconItemCategory,
    DropdownMenuAnimation,
    IconBase,
    IconArrowBottom,
    InlineSvg
  },
  computed: {
    ...mapState({
      colorCode: () => commons.colorCode
    })
  }
})
export default class TheCategoryList extends Vue {
  @Prop({ type: Array, required: true }) categories!: any;
  @Prop({ type: Boolean, required: false, default: false }) link!: boolean;

  get itemCategories() {
    return this.categories;
  }

  clickOnSubcategory(id: number) {
    if (this.link) {
      window.location.href = "/product-list/?product-category=" + id;
    } else {
      window.history.pushState("", "", "/product-list/?product-category=" + id);
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      this.$emit("click-subcategory", id);
    }
  }

  clickOnMainCategory(id: number) {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
    this.$emit("click-subcategory", id);
  }
}
